import { Skeleton } from '@mui/material';
import { Stack } from '@mui/system';
import { FunctionComponent } from 'react';

export const CheckboxItemSkeleton: FunctionComponent = () => {
  return (
    <Stack direction="row" width="100%" spacing={2}>
      <Skeleton variant="circular" width={50} height={50} />
      <Stack direction="column" width="100%">
        <Skeleton />
        <Skeleton width="60%" />
      </Stack>
    </Stack>
  );
};
